<template>
  <div class="text-white">
    <div v-if="hasRNE">
      <div class="row mb-4">
        <div class="col">
          <h4>{{ studentData.first_name }} {{ studentData.last_name }}</h4>
        </div>
        <div class="col">
          <h4 class="mb-0">
            RNE: {{ studentData.rne }}
          </h4>
          <small>
            <a
              href="#"
              class="text-white"
              @click.prevent="notMyRNE"
            ><u>Este no es mi RNE</u></a>
          </small>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            Desde la base de datos hemos cargado la siguiente información asociada a tu RNE.
            En caso de que no esté correcta, puedes modificarla:
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="text-center">
        Para poder orientarte y acompañarte en este proceso necesitamos conocerte un poco.
      </p>
    </div>
    <form
      class="needs-validation"
      novalidate
      @submit.prevent.stop="onDataSubmit"
    >
      <div class="text-center">
        <h5 class="student-data-title">
          Género
        </h5>
        <div class="btn-group-toggle student-data-btn-group">
          <label
            for="F"
            class="btn btn-white btn-block"
            :class="{ 'active': gender === 'F' }"
          >
            <input
              id="F"
              v-model="gender"
              type="radio"
              name="student-gender"
              value="F"
              autocomplete="off"
              required
            >Femenino
            <div class="invalid-feedback">Escoge una opción por favor.</div>
          </label>

          <label
            for="M"
            class="btn btn-white btn-block"
            :class="{ 'active': gender === 'M' }"
          >
            <input
              id="M"
              v-model="gender"
              type="radio"
              name="student-gender"
              value="M"
              autocomplete="off"
              required
            >Masculino
            <div class="invalid-feedback">Escoge una opción por favor.</div>
          </label>
        </div>
      </div>
      <div class="text-center">
        <h5 class="student-data-title">
          Tipo de institución educativa
        </h5>
        <div class="btn-group-toggle student-data-btn-group">
          <label
            for="private"
            class="btn  btn-white btn-block"
            :class="{ 'active': schoolType === 'private' }"
          >
            <input
              id="private"
              v-model="schoolType"
              type="radio"
              name="student-school"
              value="private"
              autocomplete="off"
              required
            >Privado
            <div class="invalid-feedback">Escoge una opción por favor.</div>
          </label>
          <label
            for="public"
            class="btn  btn-white btn-block"
            :class="{ 'active': schoolType === 'public' }"
          >
            <input
              id="public"
              v-model="schoolType"
              type="radio"
              name="student-school"
              value="public"
              autocomplete="off"
              required
            >Público
            <div class="invalid-feedback">Escoge una opción por favor.</div>
          </label>
        </div>
      </div>
      <div class="text-center">
        <h5 class="student-data-title">
          Pruebas nacionales
        </h5>
        <div class="row justify-content-center">
          <div class="col mb-2">
            <p>
              En cada asignatura, ubica el puntaje
              <b>que obtuviste{{ `${!hasRNE ? ' o crees que vas a obtener' : ''}` }}</b>:
            </p>
          </div>
        </div>
        <div class="sliders">
          <div class="row align-items-center">
            <div class="col-4 text-left">
              <label for="math">Matemáticas</label>
            </div>
            <div class="col-8">
              <score-slider
                v-model="math"
                white
              />
            </div>
          </div>
          <hr class="mx-3">
          <div class="row align-items-center">
            <div class="col-4 text-left">
              <label for="lang">Lenguaje</label>
            </div>
            <div class="col-8">
              <score-slider
                v-model="lang"
                white
              />
            </div>
          </div>
          <hr class="mx-3">
          <div class="row align-items-center">
            <div class="col-4 text-left">
              <label for="soc">Ciencias sociales</label>
            </div>
            <div class="col-8">
              <score-slider
                v-model="soc"
                white
              />
            </div>
          </div>
          <hr class="mx-3">
          <div class="row align-items-center">
            <div class="col-4 text-left">
              <label for="sci">Ciencias de la naturaleza</label>
            </div>
            <div class="col-8">
              <score-slider
                v-model="sci"
                white
              />
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5">
        <button
          class="continue-btn"
          :disabled="submitButtonDisabled"
          type="submit"
        >
          Comenzar a explorar <img
            src="../../assets/continue-icon.svg"
            alt=""
          >
        </button>
      </div>
      <!-- <button
        class="btn btn-white active"
        :disabled="false"
        type="submit"
      >
        Comenzar a explorar
      </button> -->
    </form>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { studentsService } from '../../_services';

export default {
    name: 'VerifyStudentData',
    data() {
        return {
            gender: null,
            schoolType: null,
            math: 0,
            lang: 0,
            soc: 0,
            sci: 0,
        };
    },
    computed: {
        ...mapGetters('authentication', {
            studentData: 'student_data',
            hasRNE: 'has_rne',
            student_uuid: 'student_uuid',
        }),
        formResponse() {
            return {
                gender: this.gender,
                school_type: this.schoolType,
                topic_grades: [
                    {
                        name: 'Matemáticas',
                        grade: this.math,
                    },
                    {
                        name: 'Lengua Española',
                        grade: this.lang,
                    },
                    {
                        name: 'Ciencias Sociales',
                        grade: this.soc,
                    },
                    {
                        name: 'Ciencias Naturales',
                        grade: this.sci,
                    },
                ],
            };
        },
    },
    mounted() {
        if (this.studentData.question_answered) {
            this.redirectToMainPage();
        }
        this.gender = this.studentData.gender;
        this.schoolType = this.studentData.school_type;

        if (!this.studentData.topic_grades) return;
        const scoreNames = {
            Matemáticas: 'math',
            'Lengua Española': 'lang',
            'Ciencias Sociales': 'soc',
            'Ciencias Naturales': 'sci',
        };
        this.studentData.topic_grades.forEach((t) => {
            this[scoreNames[t.name]] = t.grade;
        });
    },
    methods: {
        ...mapActions('authentication', ['setQuestionsToAnswered']),
        ...mapMutations('loginDialog', ['setCurrentDialog']),
        notMyRNE() {
            this.setCurrentDialog('TellUsAboutYourself');
        },
        redirectToMainPage() {
            return this.$router.push({ name: 'explorer' });
        },
        goToNextQuestion() {
            return this.$router.push({ name: 'regions', params: { student_data: this.studentData } });
        },
        checkValidity(e) {
            return new Promise((resolve, reject) => {
                if (e.target.checkValidity()) resolve(); else {
                    reject(new Error('One or more form fields do not contain valid data'));
                }
            });
        },
        submitResponses() {
            return studentsService.postInitialQuestions(this.student_uuid, this.formResponse);
        },
        onDataSubmit(e) {
            this.checkValidity(e)
                .then(this.submitResponses)
                .then(this.setQuestionsToAnswered)
                // .then(this.redirectToMainPage)
                .then(this.goToNextQuestion)
                .catch((err) => {
                    e.stopPropagation();
                    throw new Error(`Problem with handling something: ${err}`);
                })
                .finally(() => { e.target.classList.add('was-validated'); });
        },
    },
};
</script>

<style lang="scss" scoped>
.student-data-title {
  // background: rgba(52, 133, 255, 0.5);
  // font-family: "Quicksand Medium", Roboto, sans-serif;
  // transform: scaleX(107%);
  border-bottom: solid 1px rgba(white, 0.2);
  text-align: left;
  padding: 0.25rem;
  margin-top: 1rem;
}
.student-data-btn-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.student-data-btn-group label {
  max-width: 16em;
}
.sliders .row {
  margin: 1em auto;
  height: 4em;
}
.btn-white{
  border-color: rgba(white, 0.2) !important;
  color:  rgba(white, 0.2)  !important;
  &.active{
    border-color: rgba(white, 1) !important;
    color:  rgba(white, 1)  !important;
    background-color: rgba(white, 0.2) !important;
  }
}
.continue-btn{
  position: absolute;
  right: 20px;
  bottom: 20px;
  background: none;
  border: none;
  text-transform: uppercase;
  color: white;
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.92;
  letter-spacing: 0.35px;
  text-align: left;
  display: flex;
  align-items: center;
  img{
    margin-left: 0.5rem;
  }
}
</style>
